// Custom radio button component

import './RadioButton.scss';

export default function RadioButton({
  label,
  name,
  value,
  selectedValue,
  onChange,
}) {
  const isChecked = value === selectedValue;

  return (
    <label className={`radio-button ${isChecked ? 'checked' : ''}`}>
      <input
        type='radio'
        name={name}
        value={value}
        checked={isChecked}
        onChange={() => onChange(value)}
        className='hidden-input'
      />
      <span className='custom-radio' />
      {label}
    </label>
  );
}
